import {User} from "@irati/types"

type UserType = Pick<User, "firstName" | "lastName">

export default (user: UserType) => {
  /** @note Added optional chaining to prevent error if `user` doesn't exist (bad data) */
  const firstname = user?.firstName || user?.firstname
  const lastname = user?.lastName || user?.lastname
  return `${firstname}${lastname ? ` ${lastname}` : ""}`
}
